import axios from 'axios'
import AbstractAxiosMock from './AbstractAxiosMock'
import { config } from '@/config'

export default class DieciContaoServiceMock extends AbstractAxiosMock {

  async 'POST /api/zip' (method, url, { zip }) {
    // DUPLICATE: DieciWebshopServiceMock
    zip = parseInt(zip)
    if (zip === 8005) {
      const result = await axios.get(config.MOCK_SEARCHZIP_URL)
      const emptyResult = await axios.get(config.MOCK_SEARCHZIP_EMPTY_URL)
      emptyResult.data.itemlist.push(...result.data.itemlist)
      return emptyResult
    } else if (zip === 8000) {
      return axios.get(config.MOCK_SEARCHZIP_URL)
    } else if (zip === 0) {
      return axios.get(config.MOCK_SEARCHZIP_URL)
    } else if (zip === 8001) {
      const result = await axios.get(config.MOCK_SEARCHZIP_URL)
      result.data.itemlist.splice(1, 5)
      return result
    } else {
      const result = await axios.get(config.MOCK_SEARCHZIP_URL)
      result.data.itemlist.splice(2, 5)
      return result
    }
  }

  async 'GET /api/slotmachine/init' (method, url) {
    const response = {
      status: true,
      items: [
        'discount',
        'giftbasket',
        'pizza',
      ],
      startItem: [
        'questionmark',
        'questionmark',
        'questionmark',
      ],
    };

    return this.fakeRequest({status: true, response});
  }

  async 'POST /api/slotmachine/play' (method, url, { firstname, lastname, email, terms, newsletter }) {
    const winningItems = [
      'pizza',
      'giftbasket',
    ];

    let scenario = 'win';

    if (email.includes('lose')) {
      scenario = 'lose';
    }
    else if (email.includes('played')) {
      scenario = 'played';
    }
    else if (email.includes('invalid')) {
      scenario = 'invalid';
    }

    const response = {
      id: Date.now(),
      scenario,
      status: true,
      error: '',
      result: [],
      data: {
        firstname,
        lastname,
        email,
        terms,
        newsletter,
      },
      prize: {},
    };

    if (scenario == 'win') {
      const winningItem = winningItems[Math.floor(Math.random() * winningItems.length)];
      response.result = [
          winningItem,
          winningItem,
          winningItem,
      ];
      response.prize = {
        title: 'Dein Preis',
        text: 'Gutschein im Wert von CHF 20.-',
        image: `/files/dieci2/images/slotmachine/${winningItem}.svg`,
      };
      response.resultTitle = 'Du hast gewonnen!';
      response.resultText = 'Um deinen Gewinn zu bekommen brauchen wir noch deine Adresse, da dein Preis mit der Post zu dir gesendet wird.';
    }
    else if (scenario == 'lose') {
      response.result = [
          'discount',
          'discount',
          'discount',
      ];
      response.resultTitle = 'Du hast gewonnen!';
      response.resultText = 'Kopiere den Code, um deinen Preis einzulösen.';
      response.consolationPrize = {
        title: 'Dein Preis',
        text: 'Gutschein im Wert von 5%',
        image: '/files/dieci2/images/slotmachine/discount.svg',
        code: 'Code 1234',
      };
    }
    else if (scenario == 'played') {
      response.status = false;
      response.error = 'Du hast heute bereits teilgenommen';
    }
    else {
      response.status = false;
      response.error = 'Bitte fülle alle Felder korrekt aus';
    }

    return this.fakeRequest({status: true, response});
  }

  async 'POST /api/slotmachine/address' (method, url, { id, street, city }) {
    let scenario = 'valid';

    if (street.includes('invalid')) {
      scenario = 'invalid';
    }

    const response = {
        scenario,
        status: true,
        error: '',
        data: {
          id,
          street,
          city
        },
    };

    if (scenario == 'invalid') {
        response.status = false;
        response.error = 'Bitte fülle alle Felder korrekt aus';
    }
    else {
        response.title = 'Danke für deine Teilnahme';
        response.text = 'Dein Preis wird dir am Ende der Kampagne auf dem Postweg zugesendet.';
    }

    return this.fakeRequest({status: true, response});
  }
}
